import { styled } from 'baseui'

export const HeaderActions = styled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  gap: '0.5rem',
})
